import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-toolbar-cammel',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule],
  templateUrl: './toolbar-cammel.component.html',
  styleUrl: './toolbar-cammel.component.scss'
})
export class ToolbarCammelComponent {

}
